document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.getElementById('CartDrawer');
  const overlay = cartDrawer.querySelector('.cart-drawer__overlay');
  const closeBtn = cartDrawer.querySelector('.cart-drawer__close');
  const cartButton = document.querySelector('.site-header-cart--button');
  const itemsContainer = document.getElementById('CartDrawerItems');
  const subtotalContainer = document.getElementById('CartDrawerSubtotal');
  const cartCountEl = document.querySelector('.site-header-cart--count');

  // ---- Drawer Functions ----
  function openDrawer() {
    cartDrawer.classList.add('active');
    overlay.style.display = 'block';
    refreshCart();
  }
  function closeDrawer() {
    cartDrawer.classList.remove('active');
    overlay.style.display = 'none';
  }

  // ---- Event Listeners ----
  if (cartButton) {
    cartButton.addEventListener('click', e => {
      e.preventDefault();
      openDrawer();
    });
  }
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  // ---- Update Header Cart Count ----
  function updateCartCount(data) {
    if (!cartCountEl) return;

    cartCountEl.textContent = data.item_count;

    if (data.item_count > 0) {
      cartCountEl.classList.add('cart-has-item');
      cartCountEl.classList.remove('cart-empty');
    } else {
      cartCountEl.classList.add('cart-empty');
      cartCountEl.classList.remove('cart-has-item');
    }
  }

  // ---- Refresh Cart ----
  function refreshCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(data => {
        itemsContainer.innerHTML = '';
        if (data.items.length === 0) {
          itemsContainer.innerHTML = '<p>Your cart is empty.</p>';
        } else {
          data.items.forEach(item => {
            const itemHTML = `
              <div class="cart-drawer__item" data-key="${item.key}">
                <img src="${item.image}" alt="${item.title}" width="60">
                <div class="cart-drawer__item-info">
                  <p>${item.product_title}</p>
                  
                  <div class="cart-drawer__qty">
                    <button class="qty-btn decrease" data-key="${item.key}">-</button>
                    <input type="number" class="qty-input" data-key="${item.key}" value="${item.quantity}" min="1">
                    <button class="qty-btn increase" data-key="${item.key}">+</button>
                  </div>

                  <p>${(item.final_line_price / 100).toLocaleString(undefined, {
                    style: 'currency',
                    currency: data.currency
                  })}</p>
                </div>
                <button class="cart-drawer__remove" data-key="${item.key}">Remove</button>
              </div>`;
            itemsContainer.insertAdjacentHTML('beforeend', itemHTML);
          });

          // Attach remove events
          itemsContainer.querySelectorAll('.cart-drawer__remove').forEach(btn => {
            btn.addEventListener('click', function() {
              const key = this.getAttribute('data-key');
              removeCartItem(key);
            });
          });

          // Attach qty button events
          itemsContainer.querySelectorAll('.qty-btn').forEach(btn => {
            btn.addEventListener('click', function() {
              const key = this.getAttribute('data-key');
              const input = itemsContainer.querySelector(`.qty-input[data-key="${key}"]`);
              let newQty = parseInt(input.value);

              if (this.classList.contains('increase')) {
                newQty++;
              } else if (this.classList.contains('decrease')) {
                newQty--; // allow going to 0
              }

              if (newQty <= 0) {
                removeCartItem(key);
              } else {
                updateCartQuantity(key, newQty);
              }
            });
          });

          // Attach direct input change events
          itemsContainer.querySelectorAll('.qty-input').forEach(input => {
            input.addEventListener('change', function() {
              const key = this.getAttribute('data-key');
              let newQty = parseInt(this.value);

              if (isNaN(newQty) || newQty <= 0) {
                removeCartItem(key);
              } else {
                updateCartQuantity(key, newQty);
              }
            });
          });
        }

        // Update subtotal
        subtotalContainer.textContent = (data.total_price / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: data.currency
        });

        // Update cart count + classes
        updateCartCount(data);
      })
      .catch(err => console.error('Cart fetch error:', err));
  }

  // ---- Remove Cart Item ----
  function removeCartItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(res => res.json())
      .then(() => {
        refreshCart();
      })
      .catch(err => console.error('Remove error:', err));
  }

  // ---- Update Cart Quantity ----
  function updateCartQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(res => res.json())
      .then(() => {
        refreshCart();
      })
      .catch(err => console.error('Quantity update error:', err));
  }

  // ---- Hijack Add-to-Cart Forms ----
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(res => res.json())
        .then(() => {
          openDrawer(); // open + refresh after adding
        })
        .catch(err => console.error('Cart add error:', err));
    });
  });

  // ---- Initial Check on Page Load ----
  fetch('/cart.js')
    .then(res => res.json())
    .then(data => {
      updateCartCount(data);
    })
    .catch(err => console.error('Initial cart fetch error:', err));
});
